import { Action } from "redux";
import {
  API_URL,
  put,
  debug,
  request,
  createDoRequestAction,
  SagaIterator,
  call,
  takeEvery,
  RequestResult,
  v,
  assertTotalSchema,
} from "../../lib";

import { doREQUEST_ERROR, doREQUEST_COMPLETE, doUNREAD_ANNOUNCEMENT_LIST_SET } from "../state";
import { getToken } from "./token_fetcher";
import { Dispatch, SetStateAction } from "react";
import { IIdentityAnnouncement } from "../../shared/db/identity_announcement";

export const REQUEST_IDENTITY_UNREAD_ANNOUNCEMENT_LIST_FETCH =
  "REQUEST_IDENTITY_UNREAD_ANNOUNCEMENT_LIST_FETCH";
export const doREQUEST_IDENTITY_UNREAD_ANNOUNCEMENT_LIST_FETCH = createDoRequestAction(
  REQUEST_IDENTITY_UNREAD_ANNOUNCEMENT_LIST_FETCH,
);

export const requestIdentityUnreadAnnouncementListFetchActionCreators = {
  doREQUEST_IDENTITY_UNREAD_ANNOUNCEMENT_LIST_FETCH,
};

interface Payload extends Action {
  payload: {
    requestId: string;
  };
  setRequestResult: Dispatch<SetStateAction<RequestResult | null>>;
}

export function* requestIdentityUnreadAnnouncementListFetch({
  payload,
  setRequestResult,
}: Payload): SagaIterator {
  debug("saga*requestIdentityUnreadAnnouncementListFetch");

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
      }),
    });
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_IDENTITY_UNREAD_ANNOUNCEMENT_LIST_FETCH,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    );
  }

  const accessToken = yield call(getToken);

  const result = yield request({
    method: "post",
    url: `${API_URL}/v1/web/identity-unread-notification-list-fetch`,
    accessToken,
  });

  if (!result.success || result.error) {
    const error = result.error || new Error("request did not succeed");
    debug(error);
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_IDENTITY_UNREAD_ANNOUNCEMENT_LIST_FETCH,
          fromPayload: payload,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    );
  }
  yield put(
    doUNREAD_ANNOUNCEMENT_LIST_SET(
      result.payload
        .filter((announcement: IIdentityAnnouncement) => announcement.enabled)
        .sort(
          (a: IIdentityAnnouncement, b: IIdentityAnnouncement) =>
            new Date(b.publishDate ?? b.updatedAt).getTime() -
            new Date(a.publishDate ?? a.updatedAt).getTime(),
        )
        .slice(0, 3),
    ),
  );

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_IDENTITY_UNREAD_ANNOUNCEMENT_LIST_FETCH,
        requestId: payload.requestId,
        payload: result,
      },
      setRequestResult,
    ),
  );
}

export function* identityUnreadAnnouncementListFetchSaga() {
  yield takeEvery(
    REQUEST_IDENTITY_UNREAD_ANNOUNCEMENT_LIST_FETCH,
    requestIdentityUnreadAnnouncementListFetch,
  );
}
